import {PopupMenu, MenuItem} from '@purpose/ui/components';
import {LOCALES} from '#i18n/constants';
import {Check} from 'lucide-react';

interface LanguagePickerPopupMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  rightMenu?: boolean;
  bottomMenu?: boolean;
  locale: string;
  onChange: (code: string) => void;
  anchorOrigin?: {vertical: 'top' | 'bottom'; horizontal: 'left' | 'right'};
  transformOrigin?: {vertical: 'top' | 'bottom'; horizontal: 'left' | 'right'};
}

const LanguagePickerPopupMenu = ({
  anchorEl,
  onClose,
  rightMenu,
  bottomMenu,
  locale,
  onChange,
  anchorOrigin,
  transformOrigin
}: LanguagePickerPopupMenuProps) => {
  return (
    <PopupMenu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      {...(rightMenu && {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        transformOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        }
      })}
      {...(bottomMenu && {
        marginTop: 50,
        minWidth: 176
      })}
    >
      {LOCALES.map((option, index) => (
        <MenuItem
          isFirst={index == 0}
          isLast={index == LOCALES.length - 1}
          key={option.code}
          label={option.name}
          onClick={() => onChange(option.code)}
          sx={{
            borderBottom:
              index !== LOCALES.length - 1 ? 'solid 1px #EEE' : 'none'
          }}
        >
          {option.name}
          {locale === option.code && <Check className="mr-0" />}
        </MenuItem>
      ))}
    </PopupMenu>
  );
};

export default LanguagePickerPopupMenu;
